// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './ProgressBar.module.scss';

const ProgressBar = ({ value, className, fillerClassName }) => (
  <div
    className={classNames(styles.progressBar, className)}
    data-testid="progress-bar"
  >
    <div
      className={classNames(styles.filler, 'h-100', fillerClassName)}
      style={{ width: `${Math.max(0, Math.min(1, value)) * 100}%` }}
    />
  </div>
);

ProgressBar.propTypes = {
  value: PropTypes.number,
  className: PropTypes.string,
  fillerClassName: PropTypes.string,
};

ProgressBar.defaultProps = {
  value: 0,
  className: null,
  fillerClassName: null,
};

export default React.memo(ProgressBar);
